import { checkInStateOn } from "../../domain/check-in/state-machine";
import { replaceCalorieAllocations } from "../../domain/planning/redistribution";
import type { Clock } from "../ports/clock";
import type { WeekPlanRepository } from "../ports/repositories";

export async function replaceWeekAllocations(
  dependencies: { weekPlans: WeekPlanRepository; clock: Clock },
  replacements: Readonly<Record<string, { readonly calories: number; readonly isLocked: boolean }>>,
): Promise<void> {
  const plan = await dependencies.weekPlans.getOpen();
  if (!plan) throw new Error("No active week plan exists");
  if (checkInStateOn(plan, dependencies.clock.today()) !== "active") {
    throw new Error("Complete the weekly check-in before preparing another week");
  }
  await dependencies.weekPlans.save(replaceCalorieAllocations(plan, replacements));
}
